// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"125": "cf91006d","192": "ccc2db66","354": "b478a622","535": "a4d580ac","609": "24893452","997": "1cb52b27",}[chunkId] + ".js"
}